// @ constants
const actionTypes = require('constants/actionTypes');
// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

const getPersoneticsSubscriptionStatusRequest = () => ({
    type: actionTypes.GET_PERSONETICS_SUBSCRIPTION_STATUS_REQUEST,
});

const getPersoneticsSubscriptionStatusSuccess = subscriptionStatus => ({
    type: actionTypes.GET_PERSONETICS_SUBSCRIPTION_STATUS_SUCCESS,
    payload: {
        subscriptionStatus
    }
});

const getPersoneticsSubscriptionStatusError = errorDescription => ({
    type: actionTypes.GET_PERSONETICS_SUBSCRIPTION_STATUS_ERROR,
    payload: {
        errorDescription
    }
});

const getPersoneticsSubscriptionStatus = () => (dispatch) => {
    dispatch(getPersoneticsSubscriptionStatusRequest());

    return APIGet({
        dispatch,
        endpoint : 'personeticsStatus'
    })
    .then((response) => {
        dispatch(getPersoneticsSubscriptionStatusSuccess(response.isSubscribed));
    })
    .catch((response) => {
        if (!!response.error) {
            dispatch(getPersoneticsSubscriptionStatusError(response.error));
        } else {
            throw response;
        }
    });
};

const postPersoneticsSubscriptionStatusRequest = () => ({
    type: actionTypes.POST_PERSONETICS_SUBSCRIPTION_STATUS_REQUEST,
});

const postPersoneticsSubscriptionStatusSuccess = () => ({
    type: actionTypes.POST_PERSONETICS_SUBSCRIPTION_STATUS_SUCCESS
});

const postPersoneticsSubscriptionStatusError = errorDescription => ({
    type: actionTypes.POST_PERSONETICS_SUBSCRIPTION_STATUS_ERROR,
    payload: {
        errorDescription
    }
});

const postPersoneticsSubscriptionStatus = (acceptedString) => (dispatch) => {
    dispatch(postPersoneticsSubscriptionStatusRequest());

    const requestData = {
        query : {
            "acceptedText": acceptedString
        }
    }

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('personeticsSubscribe'),
        requestData,
    )
    .then(() => {
        dispatch(postPersoneticsSubscriptionStatusSuccess());
    })
    .catch((response) => {
        if (!!response.error) {
            dispatch(postPersoneticsSubscriptionStatusError(response.error));
        } else {
            throw response;
        }
    });
};

const postPersoneticsUnsubscriptionStatusRequest = () => ({
    type: actionTypes.POST_PERSONETICS_UNSUBSCRIPTION_STATUS_REQUEST,
});

const postPersoneticsUnsubscriptionStatusSuccess = () => ({
    type: actionTypes.POST_PERSONETICS_UNSUBSCRIPTION_STATUS_SUCCESS,
});

const postPersoneticsUnsubscriptionStatusError = errorDescription => ({
    type: actionTypes.POST_PERSONETICS_UNSUBSCRIPTION_STATUS_ERROR,
    payload: {
        errorDescription
    }
});

const postPersoneticsUnsubscriptionStatus = () => (dispatch) => {
    dispatch(postPersoneticsUnsubscriptionStatusRequest());

    return APIPost({
        dispatch,
        endpoint : 'personeticsUnsubscribe'
    })
    .then(() => {
        dispatch(postPersoneticsUnsubscriptionStatusSuccess());
    })
    .catch((response) => {
        if (!!response.error) {
            dispatch(postPersoneticsUnsubscriptionStatusError(response.error));
        } else {
            throw response;
        }
    });
};

const openPersoneticsSubscriptionModal = () => ({
    type: actionTypes.OPEN_PERSONETICS_SUBSCRIPTION_MODAL
});

const openPersoneticsUnsubscriptionModal = () => ({
    type: actionTypes.OPEN_PERSONETICS_UNSUBSCRIPTION_MODAL
});

const closePersoneticsModal = () => ({
    type: actionTypes.PERSONETICS_SUBSCRIPTION_UNSUBSCRIPTION_CLOSE_MODAL
});

const termsAndConditionscheckboxClick = (termsAndConditionChecked) => ({
    type: actionTypes.PERSONETICS_SUBSCRIPTION_TERMS_AND_CONDS_CHECKBOX_CLICK,
    payload: {
        termsAndConditionChecked
    }
});

module.exports = {
    closePersoneticsModal,
    getPersoneticsSubscriptionStatus,
    openPersoneticsSubscriptionModal,
    openPersoneticsUnsubscriptionModal,
    postPersoneticsSubscriptionStatus,
    postPersoneticsUnsubscriptionStatus,
    termsAndConditionscheckboxClick
};
